import styled from "styled-components";

export const StyledNavigation = styled.nav`
   ${({ customStyle }) => customStyle && customStyle};
`;